import { IErmCapabilityApiClientServiceConfig } from './erm-capability-api-client.service-config';
import { ErmCapabilityApiClientService } from './erm-capability-api-client.service';
import { IErmApiClientConfig } from '../erm-api-client-config';
import { ErmApiClientBuilderService } from '../erm-api-client-builder.service';

export function ErmCapabilityApiClientServiceFactory(apiClientConfig: IErmApiClientConfig, builder: ErmApiClientBuilderService): ErmCapabilityApiClientService {
  const config: IErmCapabilityApiClientServiceConfig = {
    baseUrl: apiClientConfig.ermCapabilityApiBaseUrl,
    enableLogging: apiClientConfig.enableLogging,
    authHeaderResolver: apiClientConfig.authHeaderResolver
  };
  return new ErmCapabilityApiClientService(config, builder);
}
